// extracted by mini-css-extract-plugin
export default {"related-content-header":"Related_related-content-header__BnYJr","related-content-header-thumbnail":"Related_related-content-header-thumbnail__E2zP8"};